import React from 'react';
import { BaseButton } from '@repo/common';
import { ReactComponent as PlusIcon } from '@repo/common/assets/icons/16px/icon_16px_plus_outline.svg';

const WorkshopDetailListHeaderText = ({ label }) => {
  return (
    <div
      className={`flex items-center w-full 
        px-3 justify-between typo-title3 text-text-primary`}
    >
      {label}

      <BaseButton icon={<PlusIcon />} size='s' isDisabled>
        Add Booking
      </BaseButton>
    </div>
  );
};

export default WorkshopDetailListHeaderText;
